import { createAction, props } from '@ngrx/store';
import { MenuProp } from './menu.prop';

export const setDataUpdates = createAction('[Menu DataUpdates] Set', props<{ has_data_updates: boolean }>());
export const incrementOrderCount = createAction('[Menu OrderCount] Increment');
export const clearOrderCount = createAction('[Menu OrderCount] Clear');
export const setOrderCount = createAction('[Menu OrderCount] Set', props<{ orders_count: number }>());
export const incrementSurveyCount = createAction('[Menu SurveyCount] Increment');
export const clearSurveyCount = createAction('[Menu SurveyCount] Clear');
export const setSurveyCount = createAction('[Menu SurveyCount] Set', props<{ surveys_count: number }>());